import React from 'react';
import { useAssets } from 'services/assets';
import { PDFPreview } from 'components/media/PDFPreview';

export const Item = ({ intl, name }) => {

  const { assets } = useAssets();
  const url = assets?.intercom?.find(asset => asset.name === name)?.url;

  return (
    <PDFPreview
      key={name}
      intl={intl}
      downloadName={name}
      url={url}
      showInDocuments={false}
    />
  );
};
